export default __webpack_public_path__ + "static/media/icn_campaign.3a473bf9.svg";